import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {ConfirmKeyParams, PlanList, PlanListAddParams, PlanListParams} from '../plan-list.model';

export enum PlanListActionTypes {
  LoadPlanLists = '[PlanList] Load PlanLists',
  AddPlanList = '[PlanList] Add PlanList',
  UpsertPlanList = '[PlanList] Upsert PlanList',
  AddPlanLists = '[PlanList] Add PlanLists',
  UpsertPlanLists = '[PlanList] Upsert PlanLists',
  UpdatePlanList = '[PlanList] Update PlanList',
  UpdatePlanLists = '[PlanList] Update PlanLists',
  DeletePlanList = '[PlanList] Delete PlanList',
  DeletePlanLists = '[PlanList] Delete PlanLists',
  ClearPlanLists = '[PlanList] Clear PlanLists',
  GetReadPlanList = '[PlanList] Get Read PlanLists',
  GetReadPlanListFails = '[PlanList] Get Plan List Fails',
  GetAddPlanList = '[PlanList] Get Add PlanList',
  GetUpdatePlanList = '[PlanList] Get Update PlanList',
  GetDeletePlanList = '[PlanList] Get Delete PlanList',
  ConfirmPlanKey = '[PlanList] Confirm Plan Key',
  SendPlanKeyMail = '[PlanList] Send Plan Key Mail',
}

export class LoadPlanLists implements Action {
  readonly type = PlanListActionTypes.LoadPlanLists;

  constructor(public payload: { planLists: PlanList[] }) {}
}

export class AddPlanList implements Action {
  readonly type = PlanListActionTypes.AddPlanList;

  constructor(public payload: { planList: PlanList }) {}
}

export class UpsertPlanList implements Action {
  readonly type = PlanListActionTypes.UpsertPlanList;

  constructor(public payload: { planList: PlanList }) {}
}

export class AddPlanLists implements Action {
  readonly type = PlanListActionTypes.AddPlanLists;

  constructor(public payload: { planLists: PlanList[] }) {}
}

export class UpsertPlanLists implements Action {
  readonly type = PlanListActionTypes.UpsertPlanLists;

  constructor(public payload: { planLists: PlanList[] }) {}
}

export class UpdatePlanList implements Action {
  readonly type = PlanListActionTypes.UpdatePlanList;

  constructor(public payload: { planList: Update<PlanList> }) {}
}

export class UpdatePlanLists implements Action {
  readonly type = PlanListActionTypes.UpdatePlanLists;

  constructor(public payload: { planLists: Update<PlanList>[] }) {}
}

export class DeletePlanList implements Action {
  readonly type = PlanListActionTypes.DeletePlanList;

  constructor(public payload: { id: string }) {}
}

export class DeletePlanLists implements Action {
  readonly type = PlanListActionTypes.DeletePlanLists;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearPlanLists implements Action {
  readonly type = PlanListActionTypes.ClearPlanLists;
}

export class GetReadPlanList implements Action {
  readonly type = PlanListActionTypes.GetReadPlanList;
  constructor(public payload: PlanListParams) {}
}

export class GetReadPlanListFails implements Action {
  readonly type = PlanListActionTypes.GetReadPlanListFails;
}

export class GetAddPlanList implements Action {
  readonly type = PlanListActionTypes.GetAddPlanList;
  constructor(public payload: { planList: PlanListAddParams }) {}
}

export class GetUpdatePlanList implements Action {
  readonly type = PlanListActionTypes.GetUpdatePlanList;
  constructor(public payload: { planList: PlanListAddParams}) {}
}

export class GetDeletePlanList implements Action {
  readonly type = PlanListActionTypes.GetDeletePlanList;
  constructor(public payload: { id: number }) {}
}

export class ConfirmPlanKey implements Action {
  readonly type = PlanListActionTypes.ConfirmPlanKey;
  constructor(public payload: {id: number}) {}
}

export class SendPlanKeyMail implements Action {
  readonly type = PlanListActionTypes.SendPlanKeyMail;
  constructor(public payload: {id: number }) {}
}

export type PlanListActions =
 LoadPlanLists
 | AddPlanList
 | UpsertPlanList
 | AddPlanLists
 | UpsertPlanLists
 | UpdatePlanList
 | UpdatePlanLists
 | DeletePlanList
 | DeletePlanLists
 | ClearPlanLists
 | GetAddPlanList
 | GetUpdatePlanList
 | GetDeletePlanList
 | ConfirmPlanKey
 | SendPlanKeyMail
 | GetReadPlanList
 | GetReadPlanListFails;
